/**
 * Quoting helpers for the Copy-for-Claude prompt (a leaf: formatForClaude and its sections both import it, it imports
 * nothing). Untrusted text is quoted line by line, so nothing inside can open a heading of its own.
 */

const MAX_NAME = 80;

/** A name safe inside a heading or an unquoted summary line: no line break of ANY kind, no parentheses, bounded. */
export function safePersonName(name: unknown): string {
  if (typeof name !== "string") return "";
  return name.replace(ALL_LINE_BREAKS, " ").replace(/[()]/g, " ").replace(/\s+/g, " ").trim().slice(0, MAX_NAME);
}

/**
 * Every line break a renderer or model may honour: CRLF, LF, CR, and the Unicode
 * breaks U+0085 (NEL), U+2028 (LINE SEPARATOR), U+2029 (PARAGRAPH SEPARATOR),
 * plus VT and FF. Kept in step with functions/src/issueTriage/promptQuoting.ts by
 * an identical expected-output table in both test suites.
 */
export const LINE_BREAKS = /\r\n|[\n\r\u0085\u2028\u2029\v\f]/;

const ALL_LINE_BREAKS = new RegExp(LINE_BREAKS.source, "g");

/** Quote untrusted text: every line (including blank ones) gets "> ". */
export function quoteLines(text: unknown): string {
  const s = typeof text === "string" ? text : text == null ? "" : String(text);
  return s
    .split(LINE_BREAKS)
    .map((line) => (line.length > 0 ? `> ${line}` : ">"))
    .join("\n");
}

/**
 * One labelled field inside the untrusted block. Labels are meant to be constants or counts; a label is still flattened
 * to one line with no bold markers, so a caller that ever builds one from reported data cannot open a line of its own.
 */
export function quotedField(label: string, value: unknown): string {
  const safeLabel = label.replace(ALL_LINE_BREAKS, " ").replace(/\*/g, "");
  return `> **${safeLabel}**\n${quoteLines(value)}`;
}
